import Nullstack from 'nullstack';
export default function IconPhoto({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-photo",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("line", {
    x1: "15",
    y1: "8",
    x2: "15.01",
    y2: "8"
  }), "   ", Nullstack.element("rect", {
    x: "4",
    y: "4",
    width: "16",
    height: "16",
    rx: "3"
  }), "   ", Nullstack.element("path", {
    d: "M4 15l4 -4a3 5 0 0 1 3 0l5 5"
  }), "   ", Nullstack.element("path", {
    d: "M14 14l1 -1a3 5 0 0 1 3 0l2 2"
  }), " ");
}